import classNames from 'classnames';
import React, { useState } from 'react';
import { MdAccountTree, MdGroupWork, MdStars } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip, Whisper } from 'rsuite';
import { GerenciadorPrecos } from '../../../../../../@types/GerenciadorPrecos';
import { TableBadge } from '../../../../../../components/TableBadge';
import {
  SET_GET_FAMILY_MODAL_IS_OPEN,
  SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN,
  selectorDataPointsExhibitionType,
} from '../../../../../../reducers/gerenciadorPrecos';
import { GetFamilyClusterModal } from '../../GetFamilyClusterListModal';
import { GetFamilyListModal } from '../../GetFamilyListModal';
import styles from './ProductCell.module.scss';

const listFormater = new Intl.ListFormat('pt-BR', { style: 'long', type: 'conjunction' });

type RowData = GerenciadorPrecos.RowData;

export type ProductCellProps = {
  rowData: RowData;
} & React.HtmlHTMLAttributes<HTMLDivElement>;

export const ProductCell = ({ className, rowData, ...props }: ProductCellProps) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalStoreFamilyClusterOpen, setModalStoreFamilyClusterOpen] = useState(false);
  const datapointsExibitionType = useSelector(selectorDataPointsExhibitionType);

  const dispatch = useDispatch();

  const handleOpenModal = () => {
    if (datapointsExibitionType === 'FAMILY') {
      setModalOpen(true);
      dispatch(SET_GET_FAMILY_MODAL_IS_OPEN(true));
    }
    if (datapointsExibitionType === 'PRODUCT_CLUSTER_FAMILY') {
      setModalStoreFamilyClusterOpen(true);
      dispatch(SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN(true));
    }
  };

  const {
    productId = '',
    description = '--',
    architectureId = null,
    refProduct = false,
    productFamilyId = undefined,
    isProductMaster = false,
    segments = [],
  } = rowData;

  return (
    <>
      <div className={classNames(styles.container, className)} {...props}>
        <div className={styles.header}>
          <span className={styles.product_id}>{productId}</span>
          {architectureId && (
            <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{architectureId}</Tooltip>}>
              <TableBadge aria-label={`Arquitetura ${architectureId}`} className={styles['architecture-badge']} skin="light-blue">
                <MdAccountTree />
                {architectureId}
              </TableBadge>
            </Whisper>
          )}
          {architectureId && refProduct && (
            <TableBadge aria-label="Produto referência" className={styles['architecture-badge']} skin="blue">
              <MdAccountTree />
              REF
            </TableBadge>
          )}
          {productFamilyId && (
            <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{productFamilyId}</Tooltip>}>
              {(rowData.itemsCountFamily !== null && rowData.itemsCountFamily > 0) ||
              (datapointsExibitionType === 'PRODUCT_CLUSTER_FAMILY' && rowData.itemsCountFamily !== null && rowData.itemsCountFamily > 0) ? (
                <>
                  <TableBadge skin="light-blue" onClick={() => handleOpenModal()}>
                    <MdGroupWork />
                    {`${rowData.itemsCountFamily}` + (rowData.itemsCountFamily > 1 ? ' ITEMS' : ' ITEM')}
                  </TableBadge>
                  <TableBadge skin="blue" onClick={() => handleOpenModal()}>
                    <MdStars />
                    {productFamilyId}
                  </TableBadge>
                </>
              ) : (
                <TableBadge
                  skin="light-blue"
                  onClick={() => {
                    handleOpenModal();
                  }}
                >
                  <MdGroupWork />
                  {productFamilyId}
                </TableBadge>
              )}
            </Whisper>
          )}
          {isProductMaster && (
            <TableBadge skin="blue">
              <MdStars />
              PAI
            </TableBadge>
          )}
        </div>
        <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{description}</Tooltip>}>
          <p className={styles.description}>{description}</p>
        </Whisper>

        {segments?.length && (
          <Whisper delayShow={0.2} trigger="hover" placement="right" speaker={<Tooltip>{listFormater.format(segments)}</Tooltip>}>
            <ul className={styles['segment-list']}>
              {segments.map(segment => (
                <li key={segment}>{segment}</li>
              ))}
            </ul>
          </Whisper>
        )}
      </div>
      {datapointsExibitionType === 'FAMILY' && (
        <GetFamilyListModal
          rowData={rowData}
          show={modalOpen}
          onHide={() => {
            setModalOpen(false);
            dispatch(SET_GET_FAMILY_MODAL_IS_OPEN(false));
          }}
        />
      )}
      {datapointsExibitionType === 'PRODUCT_CLUSTER_FAMILY' && (
        <GetFamilyClusterModal
          rowData={rowData}
          show={modalStoreFamilyClusterOpen}
          onHide={() => {
            setModalStoreFamilyClusterOpen(false);
            dispatch(SET_GET_STORE_FAMILY_CLUSTER_MODAL_IS_OPEN(false));
          }}
        />
      )}
    </>
  );
};
